export class TransactionTaxDto {
  public taxRate: number;
  public percent: number;
  public amount: number;
  public totalTaxable: number;
}
